import NextLink from 'next/link';
import { datadogRum } from '@datadog/browser-rum';
import { SidebarMenuButton } from '@savvy-kit/templates/sidebar';
import { MessageSquareText } from 'lucide-react';
import { DatadogRumAction } from 'src/utils/logging';

function ShareFeedbackMenuButton() {
  return (
    <SidebarMenuButton tooltip="Share Feedback">
      <NextLink
        href="/advisor/dashboard/share_feedback"
        className="relative flex items-center gap-2 w-full"
        onClick={() => {
          datadogRum.addAction(DatadogRumAction.ShareFeedbackClicked);
        }}
      >
        <MessageSquareText className="size-4 shrink-0" />
        <span>Share Feedback</span>
      </NextLink>
    </SidebarMenuButton>
  );
}

export default ShareFeedbackMenuButton;
